<template>
  <div id="app">
    <Navigation />
    <router-view />
  </div>
</template>

<script>
import NavigationComp from "./components/Navigation.vue";

export default {
  name: "App",
  components: { Navigation: NavigationComp },
};
</script>

<style>
/* 全局样式重置 */
body {
  margin: 0;
  font-family: "Poppins", sans-serif;
}
</style>